export interface PurchaseLogFileLink {
	description: string;
	fileName: string;
	lookupId: string;
}

export class PurchaseLogFileLink implements PurchaseLogFileLink {
	description = "";
	fileName = "";
	lookupId = "";

	constructor(data?: Partial<PurchaseLogFileLink>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}